import gql from 'graphql-tag'

export const fetchUpdateCartItemsMutation = gql(`
mutation ($cart_id: String!, $cart_items: [CartItemUpdateInput]!) {
  updateCartItems(
    input: {
      cart_id: $cart_id
      cart_items: $cart_items
    }
  ) {
      cart {
        grand_total_your_price_details
        free_beer_active
        items {
          id
          is_free_beer
          prices {
            price_details
            multi_deposit_details 
          }
          quantity
          quantity_total
          number_of_packages
          number_of_layer
          number_of_layer_total
          number_of_layer_freebeer 
          number_of_pallet
          product {
            hectolitres_fe
            additional_weight
            special_offer_details{
              max_purchasable_qty
              valid_from
              valid_to
              deliverable_from
              deliverable_to
              deliverable_flag
              layer_error_flag
            }
          }    
        }
      }
    }
  }
`)
